import { useSearchParamsContext } from '../../contexts/SearchParamsContext';
import {
  FilterableQueryOptionsType,
  FilterableQueryResultType,
  FiltersInterface,
} from '../../types';

interface FetchDataProps<T> {
  request: (
    filters: FiltersInterface,
    options?: FilterableQueryOptionsType<T>
  ) => FilterableQueryResultType<T>;
  children: (data: FilterableQueryResultType<T>) => React.ReactNode;
}

export function FetchData<T>({ children, request }: FetchDataProps<T>) {
  const { searchParams } = useSearchParamsContext();

  const data = request(searchParams);

  return <>{children(data)}</>;
}
